import React from 'react';
import Passdown from './passdown/Passdown';
import CalendarSection from './calendar/CalendarSection';
import Announcements from './announcements/Announcements';
import AssignedTrainings from './assigned-trainings/AssignedTrainings';
import RecentSOPs from './sops/RecentSOPs';
import { useUser } from 'src/context/UserContext';
import './Dashboard.scss';

const Dashboard = () => {
    const { canRead } = useUser();
    const showPassdown = canRead('globalShiftPassdown') || canRead('alarmsShiftPassdown') || canRead('csShiftPassdown') || canRead('csirShiftPassdown') || canRead('cmShiftPassdown') || canRead('eventsShiftPassdown') || canRead('oimShiftPassdown');

    return (
        <div className="dashboard">
            <div className="dashboard__main">
                <div className="dashboard__left">
                    {showPassdown
                        ? <div id="passdowns"><Passdown /></div>
                        : <div id="announcements"><Announcements /></div>
                    }
                </div>
                <div className="dashboard__right">
                    <div id="trainings"><AssignedTrainings /></div>
                    <div id="sops"><RecentSOPs /></div>
                </div>
            </div>
            {showPassdown && <div id="announcements"><Announcements defaultVisibleCount={3}/></div>}
            <div id="calendar"><CalendarSection /></div>
        </div>
    );
};

export default Dashboard;
